export default "__VITE_ASSET__DiLYa1FY__"